import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비등록 > 서버] 서버를 추가한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  insertServer(params) {
    return axios.post(`${baseUrl}/settings/device-registration-sms/insert-server.do`, params);
  },
  /**
   * [장비등록 > 서버] 서버목록을 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getServerList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-sms/get-server-list.do`, params);
  },
  /**
   * [장비등록 > 서버] 관리대상 등록 화면의 최근 등록장비 갯수를 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getRecentRegisteredServerCount() {
    return axios.get(`${baseUrl}/settings/device-registration-sms/get-recent-registered-server-count.do`);
  },
  /**
   * [장비등록 > 서버] 관리대상 등록 화면의 선택된 서버들을 삭제한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteServerList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-sms/delete-server-list.do`, params);
  },
  /**
   * [장비등록 > 서버] 관리대상 등록 화면의 선택된 서버들을 수정한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateServerList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-sms/update-server-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-sms.js